'use strict';

require('file?name=locales/common/fi.json!./locales/common/fi.json');
require('file?name=locales/common/en.json!./locales/common/en.json');
require('file?name=locales/common/sv.json!./locales/common/sv.json');
require('file?name=locales/common/ru.json!./locales/common/ru.json');
require('file?name=locales/common/de.json!./locales/common/de.json');

require('file?name=locales/supergolf/fi.json!./locales/supergolf/fi.json');

require('file?name=locales/kristinacruises/fi.json!./locales/kristinacruises/fi.json');
require('file?name=locales/kristinacruises/en.json!./locales/kristinacruises/en.json');

require('file?name=locales/elamysmatkat/fi.json!./locales/elamysmatkat/fi.json');
require('file?name=locales/elamysmatkat/en.json!./locales/elamysmatkat/en.json');

require('file?name=locales/youtravel/fi.json!./locales/youtravel/fi.json');
require('file?name=locales/youtravel/en.json!./locales/youtravel/en.json');

require('file?name=locales/kalajoki/fi.json!./locales/kalajoki/fi.json');
require('file?name=locales/kalajoki/en.json!./locales/kalajoki/en.json');
require('file?name=locales/kalajoki/sv.json!./locales/kalajoki/sv.json');

require('file?name=locales/pohjolanmatkat/fi.json!./locales/pohjolanmatkat/fi.json');
require('file?name=locales/snowpanda/fi.json!./locales/snowpanda/fi.json');
require('file?name=locales/snowpanda/en.json!./locales/snowpanda/en.json');
require('file?name=locales/snowpanda/sv.json!./locales/snowpanda/sv.json');

require('file?name=locales/merilappi/fi.json!./locales/merilappi/fi.json');
require('file?name=locales/merilappi/en.json!./locales/merilappi/en.json');
require('file?name=locales/merilappi/sv.json!./locales/merilappi/sv.json');
require('file?name=locales/merilappi/ru.json!./locales/merilappi/ru.json');
require('file?name=locales/merilappi/de.json!./locales/merilappi/de.json');
require('file?name=locales/merilappi/zh.json!./locales/merilappi/zh.json');

require('file?name=locales/syote/fi.json!./locales/syote/fi.json');
require('file?name=locales/syote/en.json!./locales/syote/en.json');

require('file?name=locales/olympia/fi.json!./locales/olympia/fi.json');
require('file?name=locales/olympia/en.json!./locales/olympia/en.json');

require('file?name=locales/kuukkeli/fi.json!./locales/kuukkeli/fi.json');
require('file?name=locales/kuukkeli/en.json!./locales/kuukkeli/en.json');

require('file?name=locales/sydansuomi/fi.json!./locales/sydansuomi/fi.json');
require('file?name=locales/sydansuomi/en.json!./locales/sydansuomi/en.json');

require('file?name=locales/matkakosonen/fi.json!./locales/matkakosonen/fi.json');

require('file?name=locales/tematkat/fi.json!./locales/tematkat/fi.json');

require('file?name=locales/visitpori/fi.json!./locales/visitpori/fi.json');

require('file?name=locales/samimatkat/fi.json!./locales/samimatkat/fi.json');

require('file?name=locales/kontiki/fi.json!./locales/kontiki/fi.json');
require('file?name=locales/kontiki/en.json!./locales/kontiki/en.json');

require('file?name=locales/paivaretket/fi.json!./locales/paivaretket/fi.json');

require('file?name=locales/uudenmaan-seuramatkat/fi.json!./locales/uudenmaan-seuramatkat/fi.json');
require('file?name=locales/uudenmaan-seuramatkat/en.json!./locales/uudenmaan-seuramatkat/en.json');


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/locales.js
// module id = 227
// module chunks = 2